import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import {
  IconButton,
  Typography
}from "@material-ui/core"
import { 
  NavigateNextOutlined
} from '@material-ui/icons'
import {
  NavLink
} from "react-router-dom"

import tableStyle from "../../assets/jss/components/requisitionTableStyle";

function CustomTable({ ...props }) {

  const { classes, tableHead, tableData, tableHeaderColor } = props;

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {
            tableData.length === 0 && (
              
              <TableRow>
                <TableCell>
                  <Typography variant="h6">
                    No Items
                  </Typography>
                </TableCell>
              </TableRow>
            
          )
          }
          {tableData.map((prop, key) => {
            
            return (
              <TableRow key={key}>

                {/* <TableCell className={classes.tableCell} >
                  {prop._id}
                </TableCell> */}
                
                <TableCell className={classes.tableCell} >
                  {prop.full_name}
                </TableCell>

                <TableCell className={classes.tableCell} >
                  {prop.email}
                </TableCell>

                <TableCell className={classes.tableCell} >
                  {prop.yoma_employee ? "Yes" : "No"}
                </TableCell>
                
                <TableCell className={classes.tableCell} >
                  {prop.current_job}
                </TableCell>
                
                <TableCell className={classes.tableCell} >
                  {prop.job_id === null ? 'Unavailable': prop.job_id.title}
                </TableCell>
                {/* <TableCell className={classes.tableCell} >
                  {prop.status}
                </TableCell> */}

                <TableCell className={classes.tableCell} >
                  { convertdate(prop._created)}
                </TableCell>

                <TableCell className={classes.tableCell} >
                  <NavLink to={`/admin/cvs/${prop._id}`}>
                    <IconButton >
                        <NavigateNextOutlined/>
                    </IconButton>
                  </NavLink>
                </TableCell> 

              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

function convertdate(date) {
  var d = new Date(date);
  return d.toLocaleString();//.slice(0, 9);
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object)
};

export default withStyles(tableStyle)(CustomTable);
